import React, { useState } from 'react';
import ProviderManager from './ProviderManager';
import FraudCaseManager from './FraudCaseManager';
import PendingRegistrationsManager from './PendingRegistrationsManager';
// Research Grants disabled
// import GrantApplicationsManager from './GrantApplicationsManager';
// Thesis Verification disabled
// import ThesisSubmissionsManager from './ThesisSubmissionsManager';
import ChangePassword from './ChangePassword';

function AdminDashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('pending');
  const [showChangePassword, setShowChangePassword] = useState(false);

  // Get admin username from localStorage
  const adminAuth = JSON.parse(localStorage.getItem('adminAuth') || '{}');
  const username = adminAuth.username || 'admin';

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    onLogout();
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* Admin Header */}
      <header style={{
        backgroundColor: '#2c3e50',
        color: 'white',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h1 style={{ margin: 0, fontSize: '24px' }}>
            Admin Panel - GLOBAL RESEARCH ORGANISATION
          </h1>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <button
              onClick={() => setShowChangePassword(true)}
              style={{
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Change Password
            </button>
            <button
              onClick={handleLogout}
              style={{
                backgroundColor: '#e74c3c',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Admin Navigation */}
      <div style={{
        backgroundColor: '#34495e',
        padding: '15px 0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          gap: '10px',
          padding: '0 20px'
        }}>
          <button
            onClick={() => setActiveTab('pending')}
            style={{
              padding: '12px 24px',
              backgroundColor: activeTab === 'pending' ? '#3498db' : '#2c3e50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '15px',
              transition: 'background-color 0.3s'
            }}
          >
            Pending Registrations
          </button>
          <button
            onClick={() => setActiveTab('providers')}
            style={{
              padding: '12px 24px',
              backgroundColor: activeTab === 'providers' ? '#3498db' : '#2c3e50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '15px',
              transition: 'background-color 0.3s'
            }}
          >
            Manage Providers
          </button>
          <button
            onClick={() => setActiveTab('fraud')}
            style={{
              padding: '12px 24px',
              backgroundColor: activeTab === 'fraud' ? '#3498db' : '#2c3e50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '15px',
              transition: 'background-color 0.3s'
            }}
          >
            Manage Fraud Cases
          </button>
        </div>
      </div>

      {/* Content Area */}
      <main style={{
        maxWidth: '1200px',
        margin: '40px auto',
        padding: '0 20px'
      }}>
        {activeTab === 'pending' && <PendingRegistrationsManager />}
        {activeTab === 'providers' && <ProviderManager />}
        {activeTab === 'fraud' && <FraudCaseManager />}
      </main>

      {/* Change Password Modal */}
      {showChangePassword && (
        <ChangePassword
          username={username}
          onClose={() => setShowChangePassword(false)}
        />
      )}
    </div>
  );
}

export default AdminDashboard;
